export const RETURN_CHANNEL_SLUG_QUERY = 'returnChannelSlug';
